import React from "react";

export default function ProtocolENUS() {
  return (
    <div>
      <h1 style={{ textAlign: "center" }}>Xiaomi Retail_Privacy Notice</h1>
      <div style={{ margin: "10px" }}>
        <p>
          By providing us with your personal data, you confirm that you have
          read the following statement and consent to the collection and
          processing of your personal data for the purposes of processing your
          request, providing you with our services, and for the administration
          and management activities relating to the same, in accordance with the
          applicable laws and our Xiaomi Privacy Policy, available at
          <a href="https://privacy.mi.com/all/languages/">
            https://privacy.mi.com/all/languages/
          </a>
          . Also, you confirm that you agree to the transfer of your personal
          data to our system for storage, where your personal data will be
          protected at a standard no lower than that in your country of
          residence.
        </p>
        <p>
          Xiaomi Retail provides you with product management, sales volume
          reporting, promotion activity management, in-store inspection and
          other services (including any other forms of service provision that
          may arise in the future). To fulfill the functions, we may collect,
          process, and share your personal information as below:
        </p>
        <p>
          <strong>User Authentication</strong>
        </p>
        <p>
          The Xiaomi Retail is only available to certain personnel, for which we
          (Xiaomi Technologies Singapore Pte. Ltd., Xiaomi Technology
          Netherlands B.V., and all their affiliates and subsidiaries within
          Xiaomi Group, hereinafter referred to as "<strong>Xiaomi</strong>")
          need to collect your Xiaomi Account information (including MID), your
          name, mobile phone number, email address voluntarily provided by you.
          In addition, we will continue to use the above personal information
          and other personal information you provide to us for purpose of
          delivery of necessary service during your use of Xiaomi Retail.
        </p>
        <p>
          We take your privacy very seriously, and we are committed to keeping
          your personal information secure. Please be assured that when we use
          such information, we will strictly comply with relevant laws and
          regulations and regulatory requirements, and will only process the
          minimum amount of personal information necessary. Xiaomi will retain
          your personal data for the period necessary for the abovementioned
          purposes, unless otherwise required under applicable laws or
          regulations. Please read our Xiaomi Privacy Policy（
          <a href="https://privacy.mi.com/all/languages/">
            https://privacy.mi.com/all/languages/
          </a>
          ）to understand your rights as a data subject and how we share, secure
          and delete your personal data.
        </p>
      </div>
    </div>
  );
}
